import { createGlobalStyle } from 'styled-components';
import { color, cssVariables, font, motion, radius, shadow, type } from './tokens';

// Page-wide rules for the Playful system: the tokens as CSS variables, the page colour, one focus
// ring, toasts, the shared keyframes, and reduced motion (every animation and the hover tilt off).
const GlobalStyles = createGlobalStyle`
  ${cssVariables()}

  body {
    background-color: ${color.surfacePage};
    color: ${color.ink};
    font-family: ${font.family};
  }

  h1 { font-size: ${type.h1.size}px; line-height: ${type.h1.line}px; font-weight: ${type.h1.weight}; letter-spacing: -0.01em; }
  h2 { font-size: ${type.h2.size}px; line-height: ${type.h2.line}px; font-weight: ${type.h2.weight}; }
  h3 { font-size: ${type.h3.size}px; line-height: ${type.h3.line}px; font-weight: ${type.h3.weight}; }
  @media only screen and (max-width: 600px) {
    h1 { font-size: ${type.h1.sm}px; line-height: ${type.h1.sm + 6}px; }
    h2 { font-size: ${type.h2.sm}px; line-height: ${type.h2.sm + 6}px; }
    h3 { font-size: ${type.h3.sm}px; line-height: ${type.h3.sm + 6}px; }
  }

  :focus-visible {
    outline: 3px solid ${color.focus};
    outline-offset: 3px;
  }

  ::selection {
    background: ${color.primary};
    color: ${color.ink};
  }

  .Toastify__toast {
    font-family: ${font.family};
    color: ${color.ink};
    background: ${color.surface};
    border: 2px solid ${color.border};
    border-radius: ${radius.md}px;
    box-shadow: ${shadow.md};
    font-weight: 500;
  }
  .Toastify__toast--success { background: ${color.successSoft}; }
  .Toastify__toast--error { background: ${color.dangerSoft}; }
  .Toastify__close-button { color: ${color.ink}; opacity: .8; }

  @keyframes tb-pop {
    0% { transform: scale(.6); opacity: 0; }
    70% { transform: scale(1.06); opacity: 1; }
    100% { transform: scale(1); }
  }
  @keyframes tb-rise {
    from { transform: translateY(24px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  @keyframes tb-float {
    0%, 100% { transform: translateY(0) rotate(var(--tb-rot, 0deg)); }
    50% { transform: translateY(-8px) rotate(var(--tb-rot, 0deg)); }
  }
  @keyframes tb-confetti {
    0% { transform: translate3d(0, -20vh, 0) rotate(0deg); opacity: 1; }
    100% { transform: translate3d(var(--tb-drift, 0px), 105vh, 0) rotate(720deg); opacity: .9; }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: .01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: .01ms !important;
      scroll-behavior: auto !important;
    }
    [data-tb-confetti] { display: none !important; }
  }
`;
export const reducedMotion = '@media (prefers-reduced-motion: reduce)';
export const fullMotion = '@media (prefers-reduced-motion: no-preference)';
export const transition = (props = 'all') => `${props} ${motion.base} ${motion.ease}`;
export default GlobalStyles;